import type { AxiosRequestConfig } from "axios";
import { api, generateQueryParamFromObj, prefix } from "@/api";
import type { Meta } from "@/store/config";
import { ExtendFieldConfType } from "@/types/configuration";
import { useSettings } from "@/store/settings";

const profileNamespace = "profile";
const configurationNamespace = "gaia";

export const getAppInit = (config: AxiosRequestConfig = {}) => {
  // Alcune varianti (es. GaiaEni) si presentano all'init con un header x-Application diverso
  const settingStore = useSettings();
  const initOverride = settingStore.effectiveVariantConfig.api.initXApplicationOverride;

  const headers = initOverride
    ? {
        ...Object.fromEntries(
          Object.entries(config.headers || {}).filter(
            ([key]) => key.toLowerCase() !== "x-application"
          )
        ),
        "x-Application": initOverride,
      }
    : config.headers;

  return api<Meta>({
    url: `${prefix}/${profileNamespace}/account/init`,
    method: "get",
    ...config,
    headers,
  });
};

// Artisan Industries API functions
export const getArtisanIndustries = (config: AxiosRequestConfig = {}) => {
  return api<any[]>({
    url: `${prefix}/gaia/artisanindustries`,
    method: "get",
    ...config,
  });
};

export const getFinancingChoices = (config: AxiosRequestConfig = {}) => {
  return api<{
    data: string[];
  }>({
    url: `${prefix}/${configurationNamespace}/financingrequest`,
    method: "get",
    ...config,
  });
};

export const getApartmentOwnershipChoices = (config: AxiosRequestConfig = {}) => {
  return api<{
    data: string[];
  }>({
    url: `${prefix}/${configurationNamespace}/apartmentownership`,
    method: "get",
    ...config,
  });
};

export const getExtendFields = (
  config: AxiosRequestConfig = {},
  entityName: string,
  additionalParams: { filterName: string; filterValue: string }
) => {
  const query = generateQueryParamFromObj(additionalParams);
  return api<{
    data: ExtendFieldConfType[];
  }>({
    url: `${prefix}/${configurationNamespace}/${entityName}/extendfields${query ? `?${query}` : ""}`,
    method: "get",
    ...config,
  });
};
